import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

export const apiInterceptor: HttpInterceptorFn = (request, next) => {
  const lang = inject(TranslateService).currentLang() || 'en';

  return next(
    addAuthToken(request).clone({
      setHeaders: {
        'Accept-Language': lang,
      },
    }),
  );
};

function addAuthToken(request: HttpRequest<unknown>): HttpRequest<unknown> {
  const token = sessionStorage.getItem(environment.tokenKey);
  const fullAccessToken = sessionStorage.getItem(environment.fullAccessTokenKey);
  const authorization = request.url.includes('drive-sense') ? `Bearer ${token}` : `Token ${token}`;

  const apiUrl = request.url.includes('drive-sense') ? environment.baseUrl : environment.apiUrl;

  if (
    request.url.includes('http') ||
    request.url.includes('https') ||
    request.url.includes('i18n')
  ) {
    return request;
  }

  if (request.url.includes('drive-sense')) {
    return request.clone({
      url: `${apiUrl}${request.url}`,
      setHeaders: {
        Authorization: authorization,
      },
    });
  }

  if (
    !request.url.includes('auth/') &&
    !request.url.includes('password_reset/') &&
    !request.url.includes('check_password_reset_token') &&
    !request.url.includes('password_reset_confirm') &&
    !request.url.includes('locators/info') &&
    !request.url.includes('locators/track')
  ) {
    return request.clone({
      url: `${apiUrl}${request.url}`,
      setHeaders: {
        Authorization: authorization,
        ...(fullAccessToken ? { 'X-Impersonation-Token': fullAccessToken } : {}),
      },
    });
  }

  return request.clone({
    url: `${apiUrl}${request.url}`,
  });
}
